export default "__VITE_ASSET__d29944b7__"